var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 243.86 96.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GDA marca") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 87.79,
    width: 243.86,
    height: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 93.28,
    width: 243.86,
    height: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.25,48.26V32.93H78.44V64.35q-10.09,6.89-17.87,9.38a61,61,0,0,1-18.42,2.48q-13.12,0-21.4-4.47A30.65,30.65,0,0,1,7.93,58.42,43.84,43.84,0,0,1,3.38,38.11q0-12.08,5-21A32.23,32.23,0,0,1,22.94,3.57Q30.42,0,43.1,0,55.31,0,61.37,2.21A23.81,23.81,0,0,1,71.43,9.07a30.54,30.54,0,0,1,6,11.79l-22,3.92a12,12,0,0,0-4.6-6.38,14.33,14.33,0,0,0-8.27-2.21,14.89,14.89,0,0,0-11.94,5.2q-4.45,5.2-4.45,16.47,0,12,4.5,17.09t12.54,5.13A23.75,23.75,0,0,0,50.54,59a39.3,39.3,0,0,0,7.94-3.77V48.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.27,1.26H126.1q10,0,16.16,2.71a26.28,26.28,0,0,1,10.18,7.79,32.27,32.27,0,0,1,5.84,11.82,55.1,55.1,0,0,1,1.81,14.28q0,11.8-2.69,18.32a30.46,30.46,0,0,1-7.47,10.91A24.46,24.46,0,0,1,139.68,73a52.91,52.91,0,0,1-13.58,2H92.27ZM115,18V58.22h5.58q7.14,0,10.16-1.59a10.72,10.72,0,0,0,4.72-5.53q1.71-3.94,1.71-12.79,0-11.72-3.82-16T120.72,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.94,62.79H187.08L183.49,75H160.24l27.7-73.7h24.84L240.47,75H216.62Zm-4.73-15.94-8.13-26.49L192,46.85Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9f99ae5012e7239fa90ead9660766e37.svg";
export { ForwardRef as ReactComponent };